import React from 'react';

import { ApplicationRoutes } from 'common/constants';
import { useAuth } from 'hooks';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Button } from '@material-ui/core';

const Login = () => {
  const { t } = useTranslation();
  const { isAuthenticated, keycloak } = useAuth();
  const history = useHistory();

  const authLogin = () => {
    keycloak && keycloak.login();
  };
  const authLogout = () => {
    history.push(ApplicationRoutes.Base);
    keycloak && keycloak.logout();
  };

  return (
    <Button
      variant={isAuthenticated ? 'outlined' : 'contained'}
      color={!isAuthenticated ? 'secondary' : 'default'}
      onClick={!isAuthenticated ? authLogin : authLogout}
    >
      {t(!!isAuthenticated ? 'logout' : 'login')}
    </Button>
  );
};

export default Login;
